function surveyQuestionDirective($compile, $injector, ItemPresenterEnum, PresenterModeEnum) {
  'use strict';

  var templateWritePresenter = function eabItem_templateWritePresenter(presenterType, presenterMode) {
    return '<survey-question-' + presenterType + ' item="surveyQuestion" mode="' + presenterMode + '"></div>';
  };

  var presenterDirectiveName = function presenterDirectiveName(type) {
    return 'surveyQuestion' + _.capitalize(type.toLowerCase()) + 'Directive';
  };

  return {
    restrict: 'A',
    replace: false,
    scope: {
      explicitPresenter: '@',
      surveyQuestion: '=',
      mode: '@'
    },
    link: function itemLinkerFn($scope, $element) {
      var presenterType;
      var _presenterMode;
      var explicitPresenter = $scope.explicitPresenter;
      var surveyQuestion = $scope.surveyQuestion;

      if (!surveyQuestion) {
        // TODO fix this because log should be injected and then reference "system"?
        log.warn('no surveyQuestion to interpolate presenter from');
        return;
      }

      presenterType = !!explicitPresenter ? ItemPresenterEnum.get(explicitPresenter) : surveyQuestion.presenter;

      presenterType = $injector.has(presenterDirectiveName(presenterType.id))
        ? presenterType
        : ItemPresenterEnum.GENERIC;

      if (!!$scope.mode) {
        _presenterMode = PresenterModeEnum.get($scope.mode).key;
      } else if (!!surveyQuestion._presenterMode) {
        _presenterMode = surveyQuestion._presenterMode;
      } else {
        _presenterMode = DEFAULT_PRESENTER_MODE;
      }

      $element.append($compile(templateWritePresenter(presenterType.id, _presenterMode))($scope));
    }
  };
}

angular.module('capability-ng-major-explorer').directive('surveyQuestion', surveyQuestionDirective);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_question/survey_question_directive.js